/** Target reference line on upskilling radar charts — longer dashes than org avg. */
export const UPSKILLING_TARGET_BORDER_DASH = [8, 6] as const;
